import { StoreSettings } from '../../Types/StoreTypes';
import { ReducerAction, ReducerHandler } from '../../Types';
import {
    SET_DEMO,
    SET_SETTINGS,
    SET_LOCAL_GROUPS,
    SET_API_BASE_URL,
    SET_WEBSOCKET_URL,
    SET_OIDC_CONFIGURATION_URL,
    SET_OIDC_LOGOUT_URL,
    SET_OIDC_AUTHORITY,
    SET_OIDC_CLIENT_ID,
    SET_OIDC_USER_IDENTIFIER,
    SET_BUG_REPORTING,
    SET_REGISTRATION_ENABLED,
    SET_VERSION,
    SET_DATA_PROTECTION_TEXT,
    SET_FEATURE_DOCUMENT_UPLOAD,
    SET_CHANGELOGS,
    SET_CHANGELOG_HASH,
    SET_BETA_ACTIVE,
    SET_SENSITIVITY_LABELS,
    SET_SYSTEM_STATUS,
    SET_RELEASE_CHANNEL,
    SET_RELOAD_SETTINGS,
    TOGGLE_DEBUG_MODE,
} from '../Actions/settingsActions';
import { DLPState } from '../../Types/Enums';

const initialState = {
    systemStatus: 'running',
    dataProtectionText: '',
    demo: false,
    betaActive: false,
    icapActive: false,
    features: {
        documentUpload: false,
    },
    sensitivityLabels: [],
    localGroups: true,
    bugreporting: false,
    registrationEnabled: false,
    version: '0.0.0',
    apiBaseUrl: '',
    websocketUrl: '',
    oidcConfiurationUrl: '',
    oidcAuthority: '',
    oidcClientId: '',
    oidcUserIdentifier: 'upn',
    oidcLogoutUrl: '',
    changelogs: [],
    changelogHash: '',
    maxCosts: 0.0,
    licences: 0,
    apiKeyLicences: 0,
    userStatistic: true,
    prePaidNotifications: false,
    proxyUrlHttp: '',
    proxyUrlHttps: '',
    proxyExceptions: '',
    proxyCertificatePem: '',
    icapAddress: '',
    summaryModel: '',
    defaultModel: '',
    embeddingModel: '',
    embeddingModelDlp: DLPState.dlp_on,
    dlpRegexes: [],
    dlpEntities: ['CREDIT_CARD', 'IBAN_CODE', 'CRYPTO', 'PHONE_NUMBER', 'EMAIL_ADDRESS', 'PERSON', 'IP_ADDRESS'],
    availableDlpEntities: {},
    allowList: [],
    publicVersion: '0.0.0',
    supportMailAddress: '',
    prePaidActive: false,
    selfUpdateActive: false,
    accountId: '',
    releaseChannel: 'stable',
    instanceSystemPrompt: '',
    bestPracticeSystemPrompt: '',
    themeIdentifier: '',
    loggerSettings: {},
    chatDuration: 'infinite',
    openaiDocumentProcessingEnabled: true,
    reloadSettings: false,
    debugMode: false,
    allowedProtocols: ['http', 'https', 'mailto', 'tel', 'sandbox', 'data'],
    additionalAllowedProtocols: [],
    knowledgebaseSearchMode: 'hybrid',
    dsgvoVersionTimestamp: 0,
    theme: {
        lightThemeImage: null,
        darkThemeImage: null,
    },
} as StoreSettings;

const settingsReducerMap: Record<string, ReducerHandler<StoreSettings>> = {
    [SET_DEMO]: (state, action) => ({ ...state, demo: action.payload }),
    [SET_SETTINGS]: (state, action) => ({ ...state, ...action.payload }),
    [SET_LOCAL_GROUPS]: (state, action) => ({ ...state, localGroups: action.payload }),
    [SET_API_BASE_URL]: (state, action) => ({ ...state, apiBaseUrl: action.payload }),
    [SET_WEBSOCKET_URL]: (state, action) => ({ ...state, websocketUrl: action.payload }),
    [SET_OIDC_CONFIGURATION_URL]: (state, action) => ({ ...state, oidcConfiurationUrl: action.payload }),
    [SET_OIDC_LOGOUT_URL]: (state, action) => ({ ...state, oidcLogoutUrl: action.payload }),
    [SET_OIDC_AUTHORITY]: (state, action) => ({ ...state, oidcAuthority: action.payload }),
    [SET_OIDC_CLIENT_ID]: (state, action) => ({ ...state, oidcClientId: action.payload }),
    [SET_OIDC_USER_IDENTIFIER]: (state, action) => ({ ...state, oidcUserIdentifier: action.payload }),
    [SET_BUG_REPORTING]: (state, action) => ({ ...state, bugreporting: action.payload }),
    [SET_REGISTRATION_ENABLED]: (state, action) => ({ ...state, registrationEnabled: action.payload }),
    [SET_VERSION]: (state, action) => ({ ...state, version: action.payload }),
    [SET_DATA_PROTECTION_TEXT]: (state, action) => ({ ...state, dataProtectionText: action.payload }),
    [SET_FEATURE_DOCUMENT_UPLOAD]: (state, action) => ({
        ...state,
        features: { ...state.features, documentUpload: action.payload },
    }),
    [SET_CHANGELOGS]: (state, action) => ({ ...state, changelogs: action.payload }),
    [SET_CHANGELOG_HASH]: (state, action) => ({ ...state, changelogHash: action.payload }),
    [SET_BETA_ACTIVE]: (state, action) => ({ ...state, betaActive: action.payload }),
    [SET_SENSITIVITY_LABELS]: (state, action) => ({ ...state, sensitivityLabels: action.payload }),
    [SET_SYSTEM_STATUS]: (state, action) => {
        if (state.systemStatus === 'updating' && action.payload === 'running') {
            window.location.reload();
        }
        return { ...state, systemStatus: action.payload };
    },
    [SET_RELEASE_CHANNEL]: (state, action) => ({ ...state, releaseChannel: action.payload }),
    [SET_RELOAD_SETTINGS]: (state, action) => ({ ...state, reloadSettings: action.payload }),
    [TOGGLE_DEBUG_MODE]: (state, action) => ({ ...state, debugMode: !state.debugMode }),
};

function settingsReducer(state: StoreSettings = initialState, action: ReducerAction): StoreSettings {
    const handler = settingsReducerMap[action.type];
    return handler ? handler(state, action) : state;
}

export default settingsReducer;
